<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="1200"
    v-model="dialog"
  >
    <template>
      <v-card>
        <v-toolbar
          color="primary"
          dark
        >

          <v-btn
            @click="handleClose"
            style="margin-right: 20px;"
          >
            Cerrar
          </v-btn>
          <v-spacer />
            <v-btn :color="selectedType === 'url' ? 'black' : 'primary'" @click="() => {selectedType='url'}" style="margin-right: 5px;">
              <span class="hidden-sm-and-down">URL</span>

              <v-icon right>
                mdi-web
              </v-icon>
            </v-btn>

            <v-btn :color="selectedType === 'content' ? 'black' : 'primary'" @click="() => {selectedType='content'}" style="margin-right: 5px;">
              <span class="hidden-sm-and-down">Content</span>

              <v-icon right>
                mdi-image
              </v-icon>
            </v-btn>

            <v-btn :color="selectedType === 'preview' ? 'black' : 'primary'" @click="() => {selectedType='preview'}">
              <span class="hidden-sm-and-down">preview</span>

              <v-icon right>
                mdi-file-find
              </v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 10px;">
          <v-card v-if="selectedType === 'url'" style="padding: 5px;">
            <table border="0" width="100%">
              <tbody>
                <tr v-if="htmls.length > 0">
                  <td>
                    <h2>HTML</h2>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) of htmls"
                  :key="`html_${index}`"
                >
                  <td>
                    <v-icon :color="item.IsUsed ? 'green' : 'red'">{{item.IsUsed ? 'mdi-check-bold' : 'mdi-close-thick'}}</v-icon> {{item.Name}}
                  </td>
                  <td>
                    {{item.URL}}
                  </td>
                </tr>
                <tr v-if="rsss.length > 0">
                  <td>
                    <h2>RSS</h2>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) of rsss"
                  :key="`rss_${index}`"
                >
                  <td>
                    <v-icon :color="item.IsUsed ? 'green' : 'red'">{{item.IsUsed ? 'mdi-check-bold' : 'mdi-close-thick'}}</v-icon> {{item.Name}}
                  </td>
                  <td>
                    {{item.URL}}
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
          <v-card v-if="selectedType === 'content'" style="padding: 5px;">
            <table border="0" width="100%">
              <tbody>
                <tr v-if="projects.length > 0">
                  <td>
                    <h2>Project</h2>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) of projects"
                  :key="`project_${index}`"
                >
                  <td>
                    {{item.Name}}
                  </td>
                  <td>
                    {{convertTime(item.LMD)}}
                  </td>
                  <td>
                    <v-btn
                      color="primary"
                      @click="handleClickDownload(item.Path, item.Name)"
                      small
                      block
                    >
                      Descargar
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
            <v-divider style="margin: 10px 0;"/>
            <table border="0" width="100%">
              <tbody>
                <tr v-if="projects.length > 0">
                  <td>
                    <h2>Content</h2>
                  </td>
                </tr>
                <tr
                  v-for="(item, index) of contents"
                  :key="`content_${index}`"
                >
                  <td>
                    <v-img
                      v-if="item.ThumbPath"
                      :src="item.ThumbPath"
                    />
                  </td>
                  <td>
                    {{item.Name}}
                  </td>
                  <td>
                    <v-btn
                      color="primary"
                      :href="item.Path"
                      small
                      block
                    >
                      Descargar
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card>
          <v-card v-if="selectedType === 'preview'" style="padding: 5px;">
            <preview-presentation
              v-if="device"
              :item="previewData"
              :network="device.Network"
            />
          </v-card>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="handleClose"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import axios from 'axios'
import apiBrightsign from '@/services/apiBrightsign'
import PreviewPresentation from '@/views/private/players/brightsign/list/previewPresentation/Index'
export default {
  components: {
    PreviewPresentation,
  },
  props: {
    apiURL: {
      type: String,
      required: true,
    },
    device: {
      type: Object,
      default: null,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    selectedType: 'url',
    projects: [],
    htmls: [],
    rsss: [],
    contents: [],
  }),
  computed: {
    token () {
      return localStorage.getItem('jwt')
    },
    previewData () {
      return { ID: this.device.PresentationID }
    },
  },
  watch: {
    device () {
      this.dialog = this.device ? true : false
    },
    'device.PresentationID' () {
      this.dialog = this.device ? true : false
      this.handleGetData()
    },
  },
  methods:{
    convertTime(v) {
      const dt = new Date(v)
      const result = `${
              dt.getDate().toString().padStart(2, '0')}/${
              (dt.getMonth()+1).toString().padStart(2, '0')}/${
              dt.getFullYear().toString().padStart(4, '0')} ${
              dt.getHours().toString().padStart(2, '0')}:${
              dt.getMinutes().toString().padStart(2, '0')}:${
              dt.getSeconds().toString().padStart(2, '0')}`

      return result === '01/01/0001 00:00:00' ? '' : result
    },
    handleClose () {
      this.errors = []
      this.onClose()
    },
    async handleGetData () {
      this.projects = []
      this.htmls = []
      this.rsss = []
      this.contents = []
      if (!this.device || !this.device.PresentationID) return
      axios.get(`${this.apiURL}/v1/private/brightsign/presentations/${this.device.PresentationID}/project?token=${this.token}&start_index=0&item_per_page=100000&search_value=`)
        .then (response => {
          this.projects = response.data
        })
        .catch (error => {
          console.log(error)
        })
      axios.get(`${this.apiURL}/v1/private/brightsign/presentations/${this.device.PresentationID}/html?token=${this.token}&start_index=0&item_per_page=100000&search_value=`)
        .then (response => {
          this.htmls = response.data
        })
        .catch (error => {
          console.log(error)
        })
      axios.get(`${this.apiURL}/v1/private/brightsign/presentations/${this.device.PresentationID}/rss?token=${this.token}&start_index=0&item_per_page=100000&search_value=`)
        .then (response => {
          this.rsss = response.data
        })
        .catch (error => {
          console.log(error)
        })
      axios.get(`${this.apiURL}/v1/private/brightsign/presentations/${this.device.PresentationID}/content?token=${this.token}&start_index=0&item_per_page=100000&search_value=`)
        .then (response => {
          this.contents = response.data
        })
        .catch (error => {
          console.log(error)
        })
    },
    handleClickDownload (uri, name, type = 'text/xml') {
      apiBrightsign.put(`/v1/private/presentations/prepare-download`, {uri})
        .then(response => {
          const blob = new Blob([JSON.parse(response.data)], { type: type.toLowerCase() })

          // Create an object URL
          const url = URL.createObjectURL(blob)
          const anchor = document.createElement('a')
          anchor.href = url
          anchor.download = name

          // Append to the DOM
          document.body.appendChild(anchor)

          // Trigger `click` event
          anchor.click()

          // Remove element from DOM
          document.body.removeChild(anchor)
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

